<script>
  export let raw
</script>

<code>{raw.replace(/`/g, '')}</code>
